<div class="steps">
  <div *ngFor="let step of steps; let i = index;" class="step" [ngClass]="allActive ? 'active' : currentStep === i ? 'active' : 'minimized'" (click)="toggleStep(i)">
    <i class={{iconsClassName[i]}}></i>
    <section class="step-header">
      <h3>{{step | translate}}</h3>
    </section>
    <section class="step-content"></section>
  </div>
  <ng-content></ng-content>
</div>
